import { ModuleWithProviders, NgModule } from '@angular/core';
import { AlreadyLoggedInComponent } from './components/already-logged-in/already-logged-in.component';
import { environment } from './environment';
import { APP_NAME } from './app-token';

@NgModule({
  declarations: [AlreadyLoggedInComponent],
  exports: [AlreadyLoggedInComponent],
})
export class AuthModule {
  public static forRoot(env, appName: string): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        { provide: environment, useValue: env },
        { provide: APP_NAME, useValue: appName },
      ],
    };
  }
}
